(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["spotlight"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function(){
    // Ciblage des boutons mobile .yv-spotlight-dot.quickView
    document.querySelectorAll('button.yv-spotlight-dot.d-block.quickView').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();       // Empêche la propagation vers les éléments parents
        const href = btn.getAttribute('data-href'); // Récupère l'URL
        if (href) {
          window.location.href = href; // Redirige vers la fiche produit
          console.log('clic détecté', href);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
